import { ItemStatus } from "@focus/interfaces/lib/common/itemFetchStatus";
import { ServerSyncStatusTypes } from "./synchronization";
import { Observable } from "rxjs/Observable";
import { StompActionskeys } from "../stomp-broker";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["SET_SYNCH_STATUS"] = "SYNCHRONIZATION_SET_SYNCH_STATUS";
    ActionTypes["SET_REDUN_STATUS"] = "SYNCHRONIZATION_SET_REDUNT_STATUS";
    ActionTypes["SET_START"] = "SYNCHRONIZATION_SET_START";
    ActionTypes["SET_PENDING"] = "SYNCHRONIZATION_SET_PENDING";
    ActionTypes["SET_ERROR"] = "SYNCHRONIZATION_SET_ERROR";
})(ActionTypes || (ActionTypes = {}));
export const setStatus = (status) => ({
    type: ActionTypes.SET_SYNCH_STATUS,
    payload: status
});
export const setRedundancyStatus = (status) => ({
    type: ActionTypes.SET_REDUN_STATUS,
    payload: status
});
export const setFetchStatusPending = () => ({ type: ActionTypes.SET_PENDING });
export const setFetchStatusError = (error) => ({
    type: ActionTypes.SET_ERROR,
    payload: error
});
const initialState = {
    status: "",
    redundancy: "",
    fetchStatus: ItemStatus.PENDING
};
export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_SYNCH_STATUS:
            const payload = action.payload;
            return Object.assign(Object.assign({}, state), { fetchStatus: ItemStatus.READY, status: payload });
        case ActionTypes.SET_REDUN_STATUS:
            const redundancy = action
                .payload;
            return Object.assign(Object.assign({}, state), { fetchStatus: ItemStatus.READY, redundancy: redundancy });
        case ActionTypes.SET_ERROR:
            return Object.assign(Object.assign({}, state), { fetchStatus: ItemStatus.ERROR });
        case ActionTypes.SET_PENDING:
            return Object.assign(Object.assign({}, state), { fetchStatus: ItemStatus.PENDING });
        default:
            return state;
    }
};
export const getStatus = (state) => state.status || "";
export const getRedundancyStatus = (state) => state.redundancy || "";
export const getFetchStatus = (state) => state.fetchStatus;
export const focusServerID = "focusServerUp";
export const listenToSyncChangesEpic = (actions$, _, { stomp }) => actions$.ofType(StompActionskeys.CONNECTED).mergeMap(() => stomp
    .subscribe(`/topic/focus/sync-status`)
    .mergeMap(res => {
    switch (res.type) {
        case ServerSyncStatusTypes.REDUNDANCY_STATUS:
            return Observable.of(setRedundancyStatus(res.payload.info));
        case ServerSyncStatusTypes.SYNCHRONISATION_STATUS:
            return Observable.of(setStatus(res.payload.info));
        default:
            return Observable.of(setFetchStatusError("Invalid message received"));
    }
})
    .startWith(setFetchStatusPending())
    .takeUntil(actions$.ofType(StompActionskeys.DISCONNECTED).take(1)));
export const StartSyncEpic = (actions$, _, { stomp }) => actions$
    .ofType(ActionTypes.SET_PENDING)
    .delay(0)
    .do(() => {
    stomp.send(`/app/focus/sync-status`);
})
    .mergeMap(() => Observable.empty());
export const middleware = [listenToSyncChangesEpic, StartSyncEpic];
export const createSynchronizationStatus = () => {
    return { actions: {}, selectors: {}, reducer, middleware };
};
//# sourceMappingURL=index.js.map